module.exports = __webpack_public_path__ + "assets/img/info-btn-ee91ec06.png";